import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function useSystemID() {
  const { systemID } = useParams();
  const [systemIDInt, setSystemIDInt] = useState();

  useEffect(() => {
    if (systemID) {
      setSystemIDInt(parseInt(systemID, 10));
    }
  }, [systemID]);

  return systemIDInt;
}
